<div class="breadcrumbLayout">
  <kendo-breadcrumb [items]="breadCrumbs" [separatorSVGIcon]="breadCrumbSeparator" (itemClick)="onBreadCrumbClicked($event)"></kendo-breadcrumb>
</div>
<div class="toolbarLayout">
  <app-tool-bar [items]="toolbarItems"></app-tool-bar>
</div>
<kendo-stacklayout>
  <div class="detailContainer" #detailContainer>
    <form [formGroup]="detailForm" (ngSubmit)="onSubmit()">
      @for (view of views; track view.title) {
      <div class="form-container">
        @for (cg of view.controls; track cg.id) {
        <div class="form-group-container">
          @switch (cg.className) {
            @case ('TabControl') {
            <div>
              <app-tab [tab]="toTab(cg)" [data]="toTab(cg).tabOptions.data"></app-tab>
            </div>
            }
            @case ('UiGroupControl') {
            <kendo-expansionpanel [title]="toGroup(cg).name | translate" [expanded]="true">
              @for (row of toGroup(cg).rows; track row) {
                  @if(!row.hideRow) {
                  <div>
                    <app-form-row [controls]="row.controls" [form]="detailForm" [submitted]="submitted" [row]="row"></app-form-row>
                  </div>
                }
              }
            </kendo-expansionpanel>
            }
            @default {
            <div>
              <app-form-control [control]="cg" [form]="detailForm" [submitted]="submitted"></app-form-control>
            </div>
            }
          }
        </div>
        }
      </div>
      }
    </form>
  </div>
  @if (openDialog) {
  <kendo-dialog title="Remove {{ name }}" [animation]="true" (close)="closeRemoveDialog()">
    <p>Confirm Delete</p> <!--"general.confirmDelete" | translate-->

    <kendo-dialog-actions>
      <button kendoButton (click)="closeRemoveDialog()" [svgIcon]="dialogNo">
        No <!--"general.no" | translate-->
      </button>
      @if (dialogIcon) {
      <button kendoButton themeColor="tertiary" (click)="remove()" [svgIcon]="dialogYes">
        @if (dialogLoader) {
        <kendo-loader size="medium" themeColor="light"></kendo-loader>
        }
        Yes <!--"general.yes" | translate-->
      </button>
      }
      @else {
      <button kendoButton themeColor="tertiary" (click)="remove()">
        @if (dialogLoader) {
        <kendo-loader size="medium" themeColor="light"></kendo-loader>
        }
        Yes <!--"general.yes" | translate-->
      </button>
      }
    </kendo-dialog-actions>
  </kendo-dialog>
  }
</kendo-stacklayout>
